import dayjs from 'dayjs';

import { SHORT_DATETIME_FORMAT } from 'constants/date';

export const formatSystemMessageTimestamp = timestamp => {
  if (!timestamp) {
    return '';
  }

  const date = dayjs(timestamp);

  if (!date.isValid()) {
    return '';
  }

  return ` · ${date.format(SHORT_DATETIME_FORMAT)}`;
};
